module.exports = __webpack_public_path__ + "img/JustAlright.93616330.jpeg";